(() => {
  'use strict';
  const root = document.querySelector('[data-early-christmas]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = s => root.querySelector(s);
  const text = JSON.parse($('[data-ec-text]').textContent);
  const grid = $('[data-product-grid]'), breedControl = $('#ec-breed'), materialControl = $('#ec-material');
  const dialog = $('.ec-dialog');
  const route = window.Shopify?.routes?.root || '/';
  const isPreview = root.dataset.preview === 'true';
  const eventEntry = !isPreview && location.pathname.replace(/\/+$/, '').endsWith('/collections/early-christmas-welcome-event');
  const eventCode = 'EC70-WELCOME-9C6F2A';
  let offerActivation;
  if (eventEntry) window.SSEarlyChristmasEntry = true;
  function activateOffer() {
    if (!eventEntry) return Promise.resolve();
    if (offerActivation) return offerActivation;
    offerActivation = fetch(`${route}cart/update.js?customily_upsell=1`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: eventCode, attributes: { _ss_early_christmas_entry: 'early-christmas-welcome-event' } })
    }).then(async response => {
      if (!response.ok) throw new Error(text.error);
      const cart = await response.json();
      if (!(cart.discount_codes || []).some(d => d.code.toUpperCase() === eventCode)) throw new Error(text.error);
      return cart;
    }).catch(error => { offerActivation = null; throw error; });
    window.SSEarlyChristmasReady = offerActivation;
    return offerActivation;
  }
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const escape = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let catalog, breed, material, toastTimer, activeProduct, lastFocus;
  const choices = new Map(), poses = new Map(), selections = new Map();
  const option = (value, selected) => `<option value="${escape(value)}"${selected ? ' selected' : ''}>${escape(value)}</option>`;
  function imageUrl(index, width = 520) {
    if (index < 0) return '';
    const u = new URL(catalog.images[index]); u.searchParams.set('width', width); return u.href;
  }
  const normalizeBreed = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function choose(p) {
    const wanted = choices.get(p.id) || p.options.map(o => o.values[0]);
    const matchedBreed = p.dog ? p.options[p.breedIndex].values.find(value => normalizeBreed(value) === normalizeBreed(breed)) : null;
    if (p.dog && !matchedBreed) return null;
    if (p.materialIndex >= 0 && !p.options[p.materialIndex].values.includes(material)) return null;
    if (p.materialIndex < 0 && material !== 'Original Color') return null;
    if (p.dog) wanted[p.breedIndex] = matchedBreed;
    if (p.materialIndex >= 0) wanted[p.materialIndex] = material;
    choices.set(p.id, wanted);
    const v = p.variants.find(v => v[3].every((idx, i) => p.options[i].values[idx] === wanted[i]));
    if (!v) return null;
    const pose = poses.get(p.id) || p.poses?.[0];
    let img = v[4];
    if (pose) img = p.poseImages[wanted[p.breedIndex]]?.[pose]?.[catalog.colors[material]] ?? -1;
    if (img < 0) return null;
    return { v, img, values: wanted.slice(), pose };
  }
  function priceHtml(v) {
    return `<div class="ec-price"><strong>${money(Math.round(v[1] * .3))}</strong><s>${money(v[1])}</s></div><p class="ec-price-note">${escape(text.withTwo)}</p>`;
  }
  function selectionText(p, s) {
    const values = s.values.filter((_, i) => i !== p.materialIndex);
    return [...values, ...(s.pose ? [s.pose] : []), material].join(' · ');
  }
  function productHref(p, s) { return `${route}products/${encodeURIComponent(p.handle)}?variant=${s.v[0]}`; }
  function render() {
    selections.clear();
    grid.innerHTML = catalog.products.map(p => {
      const s = choose(p); if (!s) return '';
      selections.set(p.id, s);
      const href = productHref(p, s);
      const extra = p.options.some((_, i) => i !== p.materialIndex && !(p.dog && i === p.breedIndex)) || p.poses;
      return `<article class="ec-card" data-product="${p.id}" data-variant="${s.v[0]}"><a class="ec-photo" href="${href}" aria-label="${escape(p.fullTitle)}"><span class="ec-badge">70% OFF · 2+</span><img src="${imageUrl(s.img)}" alt="${escape(p.title + ' — ' + selectionText(p, s))}" width="520" height="520" loading="${selections.size <= 4 ? 'eager' : 'lazy'}" decoding="async"></a><div class="ec-card-body"><h3><a href="${href}">${escape(p.title)}</a></h3><p class="ec-selection">${escape(selectionText(p, s))}</p>${priceHtml(s.v)}<button class="ec-add" data-add="${p.id}"${s.v[2] ? '' : ' disabled'} aria-label="${escape(text.quickAdd + ': ' + p.title)}">${escape(s.v[2] ? text.quickAdd : text.soldOut)}${extra && s.v[2] ? ' <span aria-hidden="true">＋</span>' : ''}</button><p class="ec-card-meta">${escape(p.hasCord ? text.cord : text.details)}</p></div></article>`;
    }).join('');
    $('[data-result-count]').textContent = `${selections.size} ${text.countLabel}`;
    $('[data-empty]').hidden = selections.size > 0;
    grid.setAttribute('aria-busy', 'false');
  }
  function toast(message) {
    const t = $('[data-toast]'); t.textContent = message; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { t.hidden = true; }, 5000);
  }
  async function updateCart() {
    await activateOffer();
    const response = await fetch(`${route}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(text.error);
    const cart = await response.json();
    const eligible = new Set(catalog.products.map(p => p.id));
    const qty = cart.items.reduce((n, i) => n + (eligible.has(i.product_id) ? i.quantity : 0), 0);
    $('[data-cart-count]').textContent = String(cart.item_count);
    $('[data-progress-title]').textContent = qty === 0 ? text.progressZero : qty === 1 ? text.progressOne : text.progressReady.replace('{count}', qty);
    $('[data-progress-detail]').textContent = isPreview ? text.previewHint : text.progressHint;
    return cart;
  }
  async function add(p, s, quantity, button) {
    if (!s || !s.v[2] || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) return;
    button.disabled = true; button.textContent = text.adding;
    try {
      await activateOffer();
      const checkUrl = new URL(`${route}products/${p.handle}`, location.origin);
      checkUrl.searchParams.set('variant', s.v[0]); checkUrl.searchParams.set('section_id', 'ss-ec-variant');
      const check = await fetch(checkUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (!check.ok) throw new Error(text.error);
      const doc = new DOMParser().parseFromString(await check.text(), 'text/html');
      const data = doc.querySelector('[data-ec-variant]');
      if (!data) throw new Error(text.error);
      const live = JSON.parse(data.textContent);
      if (Number(live.id) !== s.v[0] || !live.available || JSON.stringify(live.options) !== JSON.stringify(s.values)) throw new Error(text.unavailable);
      const properties = { _soulyshine_variant_image: catalog.images[s.img], _soulyshine_variant_image_alt: selectionText(p, s) };
      if (s.pose) properties.Pose = s.pose;
      const response = await fetch(`${route}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: s.v[0], quantity, properties }], sections: ['cart-icon-bubble'], sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || text.error);
      if (result.sections?.['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = (parsed.querySelector('.shopify-section') || parsed.body).innerHTML;
      }
      if (dialog.open) dialog.close();
      toast(text.added);
      try { await updateCart(); } catch { toast(text.added); }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'early-christmas' } }));
    } catch (error) {
      toast(error.message || text.error);
    } finally {
      button.disabled = false; button.textContent = text.quickAdd;
    }
  }
  function openDialog(p) {
    activeProduct = p; lastFocus = document.activeElement;
    const s = choose(p); if (!s) return;
    const options = p.options.map((o, i) => {
      if (i === p.materialIndex || p.dog && i === p.breedIndex) return '';
      return `<label><span>${escape(o.name)}</span><select data-option="${i}">${o.values.map(v => option(v, v === s.values[i])).join('')}</select></label>`;
    }).join('');
    const pose = p.poses ? `<label><span>${escape(text.pose)}</span><select data-pose>${p.poses.map(v => option(v, v === s.pose)).join('')}</select></label>` : '';
    $('[data-dialog-content]').innerHTML = `<img data-dialog-image src="${imageUrl(s.img)}" alt="${escape(p.title)}" width="140" height="140"><h2 id="ec-dialog-title">${escape(p.title)}</h2><p class="ec-dialog-summary" data-dialog-summary>${escape(selectionText(p, s))}</p>${options}${pose}<label><span>${escape(text.quantity)}</span><input type="number" data-quantity min="1" max="99" step="1" value="1" inputmode="numeric"></label><div data-dialog-price>${priceHtml(s.v)}</div><button class="ec-dialog-add" data-confirm>${escape(text.quickAdd)}</button><a class="ec-dialog-link" href="${productHref(p, s)}">${escape(text.personalize)}</a>`;
    dialog.showModal(); document.documentElement.classList.add('ec-dialog-open');
  }
  grid.addEventListener('click', event => {
    const button = event.target.closest('[data-add]'); if (!button) return;
    const p = catalog.products.find(p => p.id === Number(button.dataset.add));
    const extra = p.options.some((_, i) => i !== p.materialIndex && !(p.dog && i === p.breedIndex)) || p.poses;
    if (extra) openDialog(p); else add(p, choose(p), 1, button);
  });
  dialog.addEventListener('change', event => {
    const p = activeProduct;
    if (event.target.matches('[data-option]')) {
      choices.get(p.id)[Number(event.target.dataset.option)] = event.target.value;
    } else if (event.target.matches('[data-pose]')) poses.set(p.id, event.target.value);
    const s = choose(p);
    $('[data-confirm]').disabled = !s || !s.v[2];
    if (!s) return;
    $('[data-dialog-image]').src = imageUrl(s.img);
    $('[data-dialog-summary]').textContent = selectionText(p, s);
    $('[data-dialog-price]').innerHTML = priceHtml(s.v);
    $('.ec-dialog-link').href = productHref(p, s);
    render();
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-close]')) dialog.close();
    if (event.target.closest('[data-confirm]')) {
      const quantity = Number($('[data-quantity]').value);
      if (!$('[data-quantity]').reportValidity()) return;
      add(activeProduct, choose(activeProduct), quantity, $('[data-confirm]'));
    }
  });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('ec-dialog-open'); const replacement = root.querySelector(`[data-add="${activeProduct?.id}"]`); (replacement || lastFocus)?.focus(); });
  function countdown() {
    const target = new Date(root.dataset.countdown).getTime();
    if (!Number.isFinite(target)) { $('.ec-countdown').hidden = true; return; }
    const total = Math.max(0, Math.floor((target - Date.now()) / 1000));
    $('[data-countdown-clock]').textContent = [Math.floor(total / 3600), Math.floor(total % 3600 / 60), total % 60].map(x => String(x).padStart(2, '0')).join(' : ');
    $('[data-countdown-clock]').dateTime = root.dataset.countdown;
  }
  countdown(); setInterval(countdown, 1000);
  activateOffer().then(() => window.SoulyshineDrawer?.refresh(false)).catch(() => toast(text.error));
  fetch(root.dataset.catalog, { credentials: 'omit' }).then(r => { if (!r.ok) throw new Error(); return r.json(); }).then(data => {
    catalog = data; breed = data.breeds.includes('Beagle') ? 'Beagle' : data.breeds[0]; material = 'Silver Plated';
    breedControl.innerHTML = data.breeds.map(b => option(b, b === breed)).join('');
    materialControl.innerHTML = data.materials.map(m => option(m, m === material)).join('');
    breedControl.disabled = false; materialControl.disabled = false;
    breedControl.addEventListener('change', () => { breed = breedControl.value; render(); });
    materialControl.addEventListener('change', () => { material = materialControl.value; render(); });
    render(); updateCart().catch(() => {});
    window.addEventListener('pageshow', () => updateCart().catch(() => {}));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) updateCart().catch(() => {}); });
    document.addEventListener('cart:updated', () => updateCart().catch(() => {}));
  }).catch(() => { grid.innerHTML = `<p>${escape(text.loadError)}</p>`; grid.setAttribute('aria-busy', 'false'); });
})();
